var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{class:{ 'is-active': _vm.isParentActive },attrs:{"to":_vm.linkDestination,"exact":""}},[_c('i',{class:_vm.route.icon}),_c('span',[_vm._v(_vm._s(_vm.route.text))]),(_vm.route.tag)?_c('span',{staticClass:"chip"},[_vm._v("Novidade")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }